import React, { useState } from 'react';
import SearchFilter from '../../../components/SearchFilter';
import EnquireParkingModal from './EnquireParkingModal';
import FilterModal from './FilterModal';
import i18n from '../../../i18n/i18n';

import SearchIcon from "../../../images/search-icon.png";
// TODO resume filter button once api ready
import FilterIcon from '../../../images/icons/filter-control.svg';
import FilterIconWhite from '../../../images/icons/filter-control-white.svg';

const FindParkingHeader = ({
  onChangeFilter
}) => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [isEnquireParkingModalOpen, setIsEnquireParkingModalOpen] = useState(false);

  return (
    <div className="sticky top-0 bg-white z-10">
      <h3 className="text-primary ml-5 pt-4 mb-1 font-bold text-[20px]">{i18n.t("findParking.search")}</h3>
      <div className="flex gap-1 mb-[20px] mx-[15px] items-center justify-center">
        <SearchFilter
          placeholder={i18n.t("findParking.parkWhere")}
          height={48}
          hideIcon={true}
          className="w-full flex items-center justify-center"
          inputClassName="w-full h-[38px] pl-[38px] pr-[40px] text-[12px] text-left rounded-[18px] bg-no-repeat bg-left-[10px] bg-top-[8px] shadow"
          style={{
            backgroundImage: `url(${SearchIcon})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "left 10px top 8px",
          }}
        />
        <button
          onClick={() => setIsFilterModalOpen(true)}
          className={`
              flex items-center justify-center gap-2
              rounded-[21px]
              py-0 px-[20px] shadow
              h-[38px] min-w-[100px]
              text-center text-[14px]
              ${localStorage.parkingFilter ? "bg-primary text-white" : "text-primary bg-white"}
            `}
        >
          <img src={localStorage.parkingFilter ? FilterIconWhite : FilterIcon} alt="filter" />
          <span>{i18n.t("findParking.filter")}</span>
        </button>
      </div>
      <div className="py-2 text-center bg-[#f6f6f6]">
        <button onClick={() => setIsEnquireParkingModalOpen(true)}>
          <p className="text-primary text-[12px]">{i18n.t("findParking.cantFind")}</p>
        </button>
      </div>
      <FilterModal onApplyFilter={onChangeFilter} onResetFilter={onChangeFilter} isModalOpen={isFilterModalOpen} onCloseModal={() => setIsFilterModalOpen(false)} />
      {isEnquireParkingModalOpen && (
        <EnquireParkingModal isModalOpen={isEnquireParkingModalOpen} onCloseModal={() => setIsEnquireParkingModalOpen(false)} />
      )}
    </div>
  )
}

export default FindParkingHeader;